import { render, staticRenderFns } from "./ItemSelect.vue?vue&type=template&id=fa120f1c"
import script from "./ItemSelect.vue?vue&type=script&lang=js"
export * from "./ItemSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports